import { ColumnType } from 'antd/es/table'
import { formatRollerDisplay } from '../../../../helpers/format-roller-display'
import RollerWithStampsCount from '../../../../types/api/roller-with-stamps-count'

export const columns: ColumnType<RollerWithStampsCount>[] = [
    {
        dataIndex: 'roller',
        title: 'Вал',
        width: 100,
        render: (v: number) => formatRollerDisplay(v),
    },
    {
        dataIndex: 'shaft',
        title: 'Зубья',
        width: 100,
    },
    {
        dataIndex: 'stamps_count',
        title: 'Кол-во штампов',
        width: 100,
    },
]
